import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '..';
export function DisplayLabel({ children }) {
    return (_jsx(Text, { className: "text-gray-800 font-medium text-sm mb-1.5", children: children }));
}
